module.exports = __webpack_public_path__ + "static/img/ABUIABAEGAAgweDjkQYo78ncogIw-As4Zg.9eb9f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABAEGAAgweDjkQYo78ncogIw-As4Zg.png
// module id = 2X5V
// module chunks = 1